export default __webpack_public_path__ + "static/media/2022_Juli_See.b51b92da.webp";